// ★★★ PC-6 R5 — o aviso depois do "Atender": de quem o LEAD ficou. Puro.
//
// `assumirAtendimento` devolve `{ levouOLead, posse: { estado, motivo, texto, dona } }`. ⚠ Desde a
// PC-6, atender a conversa NÃO leva o lead quando ele está travado com outra pessoa (N2, N3) — e
// sem este aviso a SDR acharia que o lead é dela (e a comissão também).
import { clinicaDeUmaSdr } from '@/leads/posseTela';

export function avisoDaPuxada(resposta, usuarioId, equipe = []) {
  if (!resposta || resposta.levouOLead) return null;
  const dona = resposta.posse?.dona;
  if (!dona?.id || dona.id === usuarioId) return null;
  // Clínica com 1 SDR (dono, 24/10): não aparece texto de reserva/trava.
  if (clinicaDeUmaSdr(equipe)) return null;
  return `A conversa é sua; o lead continua com ${dona.nome || 'outra pessoa'}. ${resposta.posse.texto ?? ''}`.trim();
}
